import { Divider } from "antd";
import React from "react";

const SectionCard = ({ title, children, className, action }) => {
  return (
    <div className={`filter-card-section ${className}`}>
      <div className="filter-card-header">
        <div className="activity-section">
          <div className="activity-title">{title}</div>
          <div className="filter-btn">{action}</div>
        </div>
        <Divider className="activity-section-divider" />
      </div>
      {children}
    </div>
  );
};

export default SectionCard;
